export const getStarEligibility = (data) => data
  && data.accounts
  && data.accounts.find(
    (account) => account.benefits.find(
      (benefit) => benefit.name === 'star' && benefit.isEligible === 'yes'
    )
  );

export default getStarEligibility;
